import { Header, MenuItem } from 'components/CapitalRevamp';
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import FastLoanInfo from './content/FastLoanInfo';
import FastLoanStep from './content/FastLoanStep';
import StatusCommonWealth from './content/StatusCommonWealth';

class StatusFastLoan extends Component {
  render() {
    return (
      <div>
        <Header />
        <MenuItem
          back
          title="Kembali ke Produk"
          onClick={() => browserHistory.push('/capital')}
        />
        <StatusCommonWealth />
        <FastLoanStep />
        <FastLoanInfo />
      </div>
    );
  }
}

export default StatusFastLoan;
